export default __webpack_public_path__ + "static/media/link.1c528f21.svg";